import tablelistApi from 'api/tablelistApi'

export default {
  create(options) {
    if (!options) throw new Error('options')

    return tablelistApi.post('/membership', options)
  },
  checkout(options) {
    if (!options) throw new Error('options')

    return tablelistApi.post('/membership-checkout', options)
  },
}



// WEBPACK FOOTER //
// ./src/api/membership/service.js